import { graphql } from '@apollo/client/react/hoc'
import { Component, Fragment } from 'react'
import gql from 'graphql-tag'
import { Link } from 'react-router-dom'
import { Badge, Button, Col, Row, Label, UncontrolledTooltip, Nav, NavItem, NavLink, Popover, PopoverBody, PopoverHeader, Progress } from 'reactstrap'
import { Query } from '@apollo/client/react/components'
import { EnumQuery, HasPermissionsQuery } from '../../Functions/querys'
import { BILLING_DAYS, GAS_LABELS } from '../../Constants'
import DriverNotes from '../../ApplicationsNew/DriverNotes'
import UpdateReturnInfo from '../../Cars/CarListNew/UpdateReturnInfo'
import ScheduleReturnForm from '../ScheduleReturnForm'
import CancelReturn from '../CancelReturn'
import NewAgreementPrice from '../NewAgreementPrice'
import UpdateAgreementInfo from '../UpdateAgreementInfo'
import Loader from '../Loader'
import Lightbox from "react-awesome-lightbox"
import "react-awesome-lightbox/build/style.css"
import toTitleCase from '../../Functions/toTitleCase'
import renderEnumToInt from '../../Functions/renderEnumToInt'
import CarTrackerModal from '../CarTrackerModal'
import CarNotes from '../CarNotes'
import DatetimeRenderer from '../DatetimeRenderer'
import UpdateCarInfo from '../UpdateCarInfo'
import { ReactComponent as Repo } from '../../assets/images/icons/repo.svg'
import UploadDocumentModal from '../DocumentModal/UploadDocumentModal'
import withApolloClient from '../../withApolloClient'
import fleetsynclogo from '../../assets/images/icons/fleetsync-logo.png'
import IncompleteReturnForm from '../IncompleteReturnForm'
import DriverSmartStatusModal from '../DriverSmartStatusModal'
import AddNewIncidentModal from '../../Incidents/IncidentModals/AddNewIncidentModal'
import { formatDuration } from '../../utils'
import { CancelAgreementPromoMutation, SEND_BEHAVIOR_REPORT } from '../../Drivers/Driver/Detail/Mutations'
import ConfirmationPopup from '../ConfirmationPopup'
import HistoryList from '../../Material/HistoryList'
import HistoryListModal from "../HistoryListModal"


const DailyMileages = gql`query DailyMileagesQuery($car_Id_Iexact: ID, $cursor: String, $first:Int!) {
    allDailyMileages(car_Id_Iexact:$car_Id_Iexact, after: $cursor, first: $first){
        edges {
            node {
                id
                pk
                dateAdded
                dateModified
                mileage
                history {
                    date
                    user
                    comment
                }
            }
        }
        pageInfo{
            endCursor
            hasNextPage
        }
    }
}`
const AgreementDetailQuery = gql`query AgreementDetailQuery($pk: Int, $id:ID, $loadDriverDetails: Boolean!, $loadCarDetails: Boolean!) {
    rental(pk:$pk,id: $id) {
        id
        pk
        startDate
        stage
        insuranceUpcharge
        agreementType
        endDate
        depositScheme
        deposit
        depositAmount
        pickupType
        notes
        isContractSigned
        participateInDriveSmart
        isPrimaryForSplitCharges
        incidentSet(isArchived:false) {
            edges {
                node {
                    id
                    pk
                    dateAdded
                    reportedBy
                    title
                    incidentDate
                    notificationDate
                    carCondition{
                        id
                        formType
                    }
                }
            }
        }
        upcomingRentalTask {
            amountToCharge
            scheduleTime
        }
        tags {
            id
            name
            color
        }
        branch {
            id
            name
        }
        splitAgreement {
            id
            driver {
                id
                name
            }
        }
        currentReturn {
            id
            pk
            autoDepositRefund
            stage
            scheduledDate
            closedDate
            dateAdded
            returnType
            returnCategory
            returnReason
            returnStage
            nextPickupDate
            gas
            isScheduled
            mileage
            damage
            notes
            metadata
            isImpound
            impoundAddress
            location{
              id
              pk
              name
            } 
            representative {
                id
                username
                firstName
                lastName
            }
        }
        carreturnSet(isDeleted:true){
            edges {
                node {
                    id
                    autoDepositRefund
                    dateAdded
                    returnType
                    returnCategory
                    returnReason
                    scheduledDate
                    cancelledDate
                    stage
                    isDeleted
                    metadata
                    representative {
                        id
                        username
                        firstName
                        lastName
                    }
                }
            }
        }
        type {
            id
            name
            returnNoticeDays
        }
        transactionSet(orderBy:"-id") {
            edges {
                node {
                    id
                    pk
                    dateAdded
                    amount
                    status
                    eventDatetime
                    balance
                    notes
                    updateFor{
                        id
                        pk
                    }
                    createdBy {
                        id
                        username
                        firstName
                        lastName
                    }
                    chargeType {
                        id
                        name
                    }
                }
            }
        }
        agreementpriceSet {
            edges {
                node {
                    id
                    price
                    interval
                    intervalUnit
                    currency { code symbol }
                    isActive
                    startDate
                    createdBy {
                        id
                        username
                        firstName
                        lastName
                    }
                    updatedBy {
                        id
                        username
                        firstName
                        lastName
                    }
                }
            }
        }
        agreementpromoSet {
            edges {
                node {
                    id
                    title
                    promoPrice
                    interval
                    intervalUnit
                    currency { code symbol }
                    isPending
                    isActive
                    isPercentage
                    startDate
                    expirationDate
                    createdBy {
                        id
                        username
                        firstName
                        lastName
                    }
                    updatedBy {
                        id
                        username
                        firstName
                        lastName
                    }
                }
            }
        }
        pickupCondition {
            id
            gas
            mileage
            carpicturesSet {
                edges {
                    node {
                        id
                        pictureUrl
                        pictureType
                        description
                    }
                }
            }
        }
        returnCondition {
            id
            carpicturesSet {
                edges {
                    node {
                        id
                        pictureUrl
                        pictureType
                        description
                    }
                }
            }
        }
        representative {
            id
            username
            firstName
            lastName
        }
        driver {
            id
            name
            balance 
            stage
            tlcLicense @include(if: $loadDriverDetails)
            dmvLicense @include(if: $loadDriverDetails)
            phone @include(if: $loadDriverDetails)
            email @include(if: $loadDriverDetails)
            paymentMethod @include(if: $loadDriverDetails) {
                id
                name
            }
            chargeDayofweek @include(if: $loadDriverDetails)
            chargeCcsurcharge @include(if: $loadDriverDetails)
            deposit
            branch{
                id
                name
            }
            paymentplanSet(status:A_1, last:1) {
                edges {
                    node {
                        id
                        status
                        paydownAmount
                        paydownOriginalBalance
                        paydownStartDate
                        history {
                            date
                            user
                            comment
                        }
                    }
                }
            }
        branch{
            id
            tenant{
                id
                customId
            }
        }
        }
        car {
            id
            pk
            year
            color
            location
            vin
            trackerStatus
            hasTracker
            notes
            branch {
                id
                name
                defaultMileageUnit
            }
            carModel @include(if: $loadCarDetails) {
                id
                make
                name
                series
                groupType {
                    id
                    name
                }
            }
            plate @include(if: $loadCarDetails) {
                id
                dmvPlate
                fhv
            }
            trackers {
                trackingId
                trackerType
            }
            activePolicy  @include(if: $loadCarDetails) {
                id
                insurancePolicy {
                    id
                    policyNumber
                    broker {
                        id
                        name
                    }
                }
            }
            equipmentSet(first: 10, removed: false) {
                edges {
                    node {
                        id
                        dateAdded
                        removed
                        customDeviceId
                        telemetryStatus
                        equipmentItems {
                            id
                            pk
                            name
                            customId
                            equipmentItemsGroup {
                                id
                                name
                            }
                        }
                    }
                }
            }
        }
        duration
        leaseToOwn {
            id
            totalLeaseAmount
            leaseTermInMonths
            status
            totalDuration
            car{
                pk make model year
            }
        }
    }
}`

const HISTORY_TABLE_HEADER = [
    { id: "date", name: "Date" },
    { id: "detail", name: "Details" },
    { id: "createdBy", name: "Created By" },
]
const PRICING_TABLE_HEADER = [
    { id: "price", name: "Price" },
    { id: "startDate", name: "Start Date" },
    { id: "status", name: "Status" },
    { id: "createdBy", name: "Created By" },
]
const RENTAL_TRANSACTIONS_HEADER = [
    { id: "id", name: "ID" },
    { id: "date_added", name: "Date Added" },
    { id: "charge_type", name: "Charge Type" },
    { id: "amount", name: "Amount($)" },
    { id: "event_datetime", name: "Event Date" },
    { id: "createdBy", name: "Created By" },
]

class RentalDetails extends Component {
    constructor(props) {
        super(props)
        this.state = {
            openModal: "",
            loading: false,
            error: null,
            rental: null,
            agreementDetailSubsection: "Transactions History",
            returnDetailSubsection: "Return Info",
            rentalDetailSubsection: "Rental Info",
            detailSubsections: this.props.viewType === "driver" ? "carDetails" : "driverDetails",
            images: null,
            transactionId: null,
            tab: "",
            cursor: null,
            dailyMileages: [],
            hasNextPage: true,
            dataLoaded: false,
            loadMore: false,
            cancelPromoSuccess: "",
            success: "",
        }
    }

    handleClose = () => {
        this.setState({
            loading: false,
            error: "",
            openModal: "",
        })
    }

    getAgreementState = (state) => {
        if (!this.props.agreementStates) {
            return "------"
        }
        let sobj = this.props.agreementStates.states.filter(s => s.name === state)
        return sobj.length ? sobj[0].description : "------"
    }

    toggleModal = (modalName) => {
        if (this.state.openModal === modalName) {
            this.setState({ openModal: "" })
        } else {
            this.setState({ openModal: modalName })
        }
    }

    toggleSectionNav = (sectionName, value) => {
        this.setState({ [sectionName]: value })
    }
    getCarReturnState = (state) => {
        if (!state) { return "------" }
        return this.props.carReturnStates?.states?.find(s => s.name === state)?.description || "------"
    }
    extractDescription = (text) => {
        return text.split(' ')
            .slice(2)
            .filter(word => !/\d/.test(word))
            .join(' ')
    };


    viewImages(object) {
        let tmpArr = []
        if (object && object.carpicturesSet && object.carpicturesSet.edges && object.carpicturesSet.edges.length > 0) {
            const toBeAdded = object.carpicturesSet.edges.map((pic, i) => ({ url: pic.node.pictureUrl, title: pic.node.pictureType }))
            tmpArr = [...tmpArr, ...toBeAdded]
        }
        this.setState({ images: tmpArr })
        this.toggleModal("viewImages")
    }
    openTransaction = (transactionId) => {
        this.setState({ openModal: "TransactionInfo", transactionId: transactionId })
    }

    handleLoadMore = (fetchMore) => {
        const { cursor } = this.state
        this.setState({ loadMore: true })
        fetchMore({
            variables: { cursor },
            updateQuery: (prevResult, { fetchMoreResult }) => {
                if (!fetchMoreResult) return prevResult

                const newEdges = fetchMoreResult.allDailyMileages.edges
                const pageInfo = fetchMoreResult.allDailyMileages.pageInfo

                this.setState((prevState) => ({
                    dailyMileages: [...prevState.dailyMileages, ...newEdges],
                    cursor: pageInfo.endCursor,
                    hasNextPage: pageInfo.hasNextPage,
                    loadMore: false
                }))
            },
        })
    };

    handleCancelPromo = async (promoId) => {
        this.setState({
            openModal: "cancelPromo" + promoId,
            cancelPromoLoading: false,
            cancelPromoError: "",
            cancelPromoSuccess: ""
        })
    };

    confirmCancelPromo = async (promoId) => {
        this.setState({ loading: true, error: "", cancelPromoSuccess: "" })

        try {
            const client = this.props.apolloClient || this.props.client
            if (this.props.hasPermissions && !this.props.hasPermissions.includes("custom_can_cancel_agreement")) {
                this.setState({
                    error: "You don't have permission to cancel this promo",
                    loading: false
                })
                return
            }

            if (!client) {
                this.setState({
                    cancelPromoError: "Apollo client not available",
                    loading: false
                })
                return
            }

            const result = await client.mutate({
                mutation: CancelAgreementPromoMutation,
                variables: {
                    input: {
                        agreementPromo: promoId,
                    }
                },
                refetchQueries: [
                    {
                        query: AgreementDetailQuery,
                        variables: {
                            pk: this.props.pk,
                            id: this.props.id,
                            loadDriverDetails: this.props.viewType === "car" ? true : false,
                            loadCarDetails: this.props.viewType === "driver" ? true : false,
                        }
                    }
                ]
            })

            if (result.data && result.data.cancelAgreementPromo && result.data.cancelAgreementPromo.ok) {
                this.setState({
                    cancelPromoSuccess: "Promo cancelled successfully!",
                    loading: false
                })

            } else {
                const errors = result.data?.cancelAgreementPromo?.errors || []
                const errorMessages = errors.map(error => error.messages).flat().join(', ')
                this.setState({
                    error: errorMessages || "Failed to cancel promo",
                    loading: false
                })
            }
        } catch (error) {
            console.error('Error canceling promo:', error)
            this.setState({
                cancelPromoError: error.message || "An error occurred while cancelling the promo",
                cancelPromoLoading: false
            })
        }
    };

    handleCloseCancelPromoPopup = () => {
        this.setState({
            openModal: "",
            cancelPromoError: "",
            cancelPromoSuccess: "",
            cancelPromoLoading: false
        })
    };

    fetchMetaData = (metadata = null, name) => {
        if (!metadata || metadata === "") {
            return
        }
        try {
            if (typeof metadata === "string") {
                metadata = JSON.parse(metadata.replace(/'/g, '"'))
            }
        } catch (e) {
            metadata = null
        }
        return metadata && metadata[name] ? metadata[name] : null
    }


    sendBehaviorReport = async () => {
        const driverId = this.props.rental?.driver?.id || this.props.driver?.id
        if (!driverId) return
        this.setState({
            loading: true,
            error: null,
            success: "",
        })
        try {
            const { data } = await this.props.apolloClient.mutate({
                mutation: SEND_BEHAVIOR_REPORT,
                variables: { driverId },
            })
            const result = data?.sendCustomerBehaviorReport
            if (!result?.ok) {
                const message =
                    result?.errors?.map(err => err.messages.join(", ")).join(" | ") ||
                    "No se pudo enviar el reporte."
                this.setState({ error: message })
            } else {
                this.setState({ success: "Report sent successfully." })
            }
        } catch (err) {
            const fallbackError = err?.message || "Error sending report."
            this.setState({ error: fallbackError })
        } finally {
            this.setState({ loading: false })
        }
    };



    confirmSendBehaviorReport = () => {
        this.sendBehaviorReport()
    };
    renderCarReturn = (carReturn, rental) => {
        return (
            <>
                {
                    <Row>
                        <Col xs={4}>
                            <Label>Return Category {carReturn.stage !== "A_5" && this.fetchMetaData(carReturn.metadata, "incomplete_return") && <><Badge color="danger text-light" id={"IR_RE"}>IR</Badge><UncontrolledTooltip target={"IR_RE"}>Incomplete Return</UncontrolledTooltip> </>}</Label>
                            <p className="columnContent">{carReturn.returnType === "Lost" ? carReturn.returnType : toTitleCase(carReturn.returnCategory)} <Badge className="text-light" color="secondary">{this.getCarReturnState(carReturn.stage)}</Badge> {carReturn.isImpound && <Badge color="danger">Impounded</Badge>}</p>
                        </Col>
                        <Col xs={4}>
                            <Label>Reason</Label>
                            <p className="columnContent">{carReturn.returnReason}</p>
                        </Col>
                        <Col xs={4}>
                            <Label>Rep</Label>
                            <p className="columnContent">{carReturn.representative ? carReturn.representative.firstName ? carReturn.representative.firstName + " " + carReturn.representative.lastName : carReturn.representative.username : "--"}</p>
                        </Col>

                        {carReturn.stage === "A_5" ? <Col xs={4}>
                            <Label>
                                <span id={"returnDateAdded" + carReturn.pk}>Date Added</span>
                            </Label>
                            <p>
                                <DatetimeRenderer datetime={carReturn.dateAdded} />
                            </p>
                        </Col> : <Col xs={4}>
                            <Label>
                                <span id={"returnIsScheduledAt" + carReturn.pk}>Scheduled Date</span>
                                <UncontrolledTooltip placement="right" target={"returnIsScheduledAt" + carReturn.pk}>Created On: {carReturn.dateAdded ? <DatetimeRenderer datetime={carReturn.dateAdded} /> : "--"}</UncontrolledTooltip>
                            </Label>
                            <p>
                                {carReturn.scheduledDate ?
                                    <>
                                        <DatetimeRenderer datetime={carReturn.scheduledDate} driverId={rental?.driver?.id || null} />
                                        <Badge className="ml-3 bos-badge-small" id={"returnIsScheduled" + carReturn.pk} color={carReturn.isScheduled ? "success" : "danger"} style={{ height: "10px", padding: "4px" }}>&nbsp;</Badge>
                                        <UncontrolledTooltip placement="right" target={"returnIsScheduled" + carReturn.pk}>{carReturn.isScheduled ? "Scheduled Return" : "Un-Scheduled Return"}</UncontrolledTooltip>
                                    </>
                                    :
                                    "--"}
                            </p>
                        </Col>}
                        <Col xs={4}>
                            <Label>{carReturn.cancelledDate ? "Cancelled Date" : "Closed Date"}</Label>
                            <p className="columnContent">{carReturn.cancelledDate ? <DatetimeRenderer datetime={carReturn.cancelledDate} /> : carReturn.closedDate ? <DatetimeRenderer datetime={carReturn.closedDate} /> : "--"}</p>
                        </Col>
                        <Col xs={4}>
                            <Label>Future Pickup Date</Label>
                            <p className="columnContent">{carReturn.nextPickupDate ? <DatetimeRenderer datetime={carReturn.nextPickupDate} driverId={rental?.driver?.id || null} /> : "--"}</p>
                        </Col>
                        <Col xs={4}>
                            <Label>Gas</Label>
                            <p className="columnContent">{carReturn.gas ? renderEnumToInt(carReturn.gas) : "--"}</p>
                        </Col>
                        <Col xs={4}>
                            <Label>Mileage</Label>
                            <p className="columnContent">
                                {carReturn.mileage
                                    ? this.props.rental && this.props.rental.car && this.props.rental.car.branch && this.props.rental.car.branch.defaultMileageUnit === "KM"
                                        ? `${Math.round(carReturn.mileage * 1.60934)} KM`
                                        : `${Math.round(carReturn.mileage)} MI`
                                    : "--"}
                            </p>
                        </Col>
                        <Col xs={4}>
                            <Label>Auto Deposit Refund</Label>
                            <p className="columnContent" style={{ color: carReturn.autoDepositRefund ? "green" : "red" }}>{carReturn.autoDepositRefund ? "YES" : "NO"}</p>
                        </Col>
                        {carReturn.isImpound && <Col xs={4}>
                            <Label>Impound Address</Label>
                            <p className="columnContent">Impound @ {carReturn.impoundAddress ? carReturn.impoundAddress : "--"}</p>
                        </Col>}
                        {carReturn && carReturn.stage && <Col xs={4}>
                            {rental.stage !== "_1" && this.state.openModal === "CancelReturn" + carReturn.id && <CancelReturn handleClose={() => this.toggleModal("")} carReturnId={carReturn.id} open={this.state.openModal === "CancelReturn" + carReturn.id} refetchQuery={() => { this.props.refetchAgreementsQuery() }} returnStages={this.props.carReturnStates} />}
                            {rental.stage !== "_1" && this.state.openModal === "previewReturn" + carReturn.id &&
                                <ScheduleReturnForm
                                    refetchQuery={() => this.props.refetchAgreementsQuery()}
                                    handleClose={() => this.toggleModal("")}
                                    rental={rental}
                                    carReturn={carReturn}
                                    car={carReturn.car}
                                    open={this.state.openModal === "previewReturn" + carReturn.id}
                                    editReturn={true}
                                    returnStages={this.props.carReturnStates}
                                    currentUser={this.props.currentUser ? this.props.currentUser : ""}
                                />
                            }
                            <Label>Action</Label><br />
                            {carReturn && carReturn.stage && this.getCarReturnState(carReturn.stage) && this.getCarReturnState(carReturn.stage) === "Awaiting Closeout" &&
                                <>
                                    <Button size="sm" className="primary" onClick={() => this.toggleModal("CloseReturn" + carReturn.id)}>CLOSE RETURN</Button>&nbsp;&nbsp;
                                </>
                            }
                            {carReturn && carReturn.stage !== "A_5" && (carReturn && carReturn.stage && ["Cancelled", "Returned", "Awaiting Closeout"].includes(this.getCarReturnState(carReturn.stage)) ?
                                <><Button size="sm" className="primary" onClick={() => this.toggleModal("previewReturn" + carReturn.id)}>PREVIEW</Button>&nbsp;&nbsp;</> :
                                <><Button size="sm" className="primary" onClick={() => this.toggleModal("CancelReturn" + carReturn.id)}>CANCEL</Button>&nbsp;&nbsp;</>
                            )}
                            {carReturn && carReturn.stage && !["Cancelled", "Awaiting Closeout", "Returned"].includes(this.getCarReturnState(carReturn.stage)) &&
                                <>
                                    <Button size="sm" className="primary" onClick={() => this.toggleModal("EditReturn" + carReturn.id)}>EDIT</Button>
                                    &nbsp;&nbsp;
                                </>
                            }

                            &nbsp;<span style={{ fontSize: 15 }} id={"returnHistory"}><i id={"returnHistory" + carReturn.pk} onClick={() => this.toggleModal("returnHistory" + carReturn.pk)} className={"fa fa-history"}></i><br /></span>
                            <UncontrolledTooltip target="returnHistory">Return Update History</UncontrolledTooltip>

                            {this.state.openModal === "returnHistory" + carReturn.pk &&
                                <HistoryListModal
                                    isOpen={this.state.openModal === "returnHistory" + carReturn.pk}
                                    toggle={() => this.toggleModal("")}
                                    title="Car Return History"
                                    objectIds={[carReturn.id]}
                                    emptyText="No return history found."
                                />
                            }
                        </Col>}
                        <Col xs={12}>
                            <br />
                            <Label id={"returnNotes" + carReturn.pk}>
                                {carReturn.stage !== "A_5" ? "Return Notes" : "Incomplete Reason"}&nbsp;&nbsp;
                                {carReturn.stage !== "A_5" && <>
                                    <i onClick={() => this.toggleModal("returnNotesEdit" + carReturn.pk)} className={"fa fa-pencil-square-o"}></i>&nbsp;&nbsp;
                                    <i onClick={() => this.toggleModal("returnNotesHistory" + carReturn.pk)} className={"fa fa-history"}></i><br />
                                </>}
                            </Label>
                            {rental.stage !== "_1" && this.state.openModal === "returnNotesEdit" + carReturn.pk &&
                                <UpdateReturnInfo carReturn={carReturn} title="Edit Return Notes" name="notes" value={carReturn.notes} target={"returnNotes" + carReturn.pk} id="returnNotes" type="text"
                                    open={this.state.openModal === "returnNotesEdit" + carReturn.pk} handleClose={() => this.toggleModal("")} refetchQuery={this.props.refetchAgreementsQuery} placement={"left"}
                                />
                            }
                            {this.state.openModal === "returnNotesHistory" + carReturn.pk &&
                                <DriverNotes driver={rental.driver} noteType="RETURN" title="Return Notes" objectId={carReturn.id} target={"returnNotes" + carReturn.pk} open={this.state.openModal === "returnNotesHistory" + carReturn.pk} handleClose={() => this.toggleModal("")} placement={"left"} />
                            }
                            <br />
                            <p>
                                {carReturn.notes && carReturn.notes.split('\n').map((line, i) =>
                                    <span key={i}>{line}</span>
                                )}
                            </p>
                        </Col>
                    </Row>
                }
                {rental.stage !== "_1" && this.state.openModal === "CloseReturn" + carReturn.id &&
                    <ScheduleReturnForm refetchQuery={this.props.refetchAgreementsQuery} handleClose={() => this.toggleModal("")} rental={rental} carReturn={carReturn} car={carReturn.car} driver={rental.driver} open={this.state.openModal === "CloseReturn" + carReturn.id} editReturn={true} closeReturn={true} returnStages={this.props.carReturnStates} currentUser={this.props.currentUser ? this.props.currentUser : ""} />
                }
                {rental.stage !== "_1" && this.state.openModal === "EditReturn" + carReturn.id && (
                    carReturn.stage === "A_5" ?
                        <IncompleteReturnForm
                            refetchQuery={this.props.refetchAgreementsQuery}
                            handleClose={() => this.toggleModal("")}
                            rentalId={this.props.rental.id}
                            carReturn={carReturn}
                            open={this.state.openModal === "EditReturn" + carReturn.id}
                            editReturn
                        /> :
                        <ScheduleReturnForm refetchQuery={() => { this.props.refetchAgreementsQuery() }} handleClose={() => this.toggleModal("")} rental={rental} carReturn={carReturn} car={carReturn.car} open={this.state.openModal === "EditReturn" + carReturn.id} editReturn={true} returnStages={this.props.carReturnStates} currentUser={this.props.currentUser ? this.props.currentUser : ""} />
                )
                }
            </>
        )
    }
    render() {
        const { dailyMileages, hasNextPage, dataLoaded } = this.state
        const { rental } = this.props
        const carIsEligibleForDriveSmart = rental?.car?.equipmentSet?.edges?.some(edge => {
            const { telemetryStatus, equipmentItems } = edge.node
            return equipmentItems?.customId === "general-motors-onstar" && (!telemetryStatus || telemetryStatus?.toString()?.toUpperCase() === "PRESENT")
        })

        return (
            <>
                <Col className="zero-padding">
                    {this.props.loading ? <Loader /> : <>
                        {this.state.openModal === "NewAgreementPrice" && <NewAgreementPrice handleClose={() => this.toggleModal("")} refetchQuery={this.props.refetchAgreementsQuery} rental={this.props.rental} open={this.state.openModal === "NewAgreementPrice"} />}
                        {this.state.openModal === "viewImages" && <Lightbox images={this.state.images} onClose={() => this.toggleModal("viewImages")} />}
                        {this.props.rental && <div className="agreement-detail">
                            <Row>
                                <Col>
                                    <Nav tabs>
                                        <NavItem className={["carDetails", "driverDetails"].includes(this.state.tab) ? "active" : "inactive"}>
                                            {this.props.viewType === "driver" ?
                                                <NavLink className={this.state.detailSubsections === "carDetails" ? "active navItem" : "navItem"} onClick={() => this.toggleSectionNav("detailSubsections", "carDetails")}>
                                                    CAR DETAILS
                                                </NavLink> :
                                                <NavLink className={this.state.detailSubsections === "driverDetails" ? "active navItem" : "navItem"} onClick={() => this.toggleSectionNav("detailSubsections", "driverDetails")}>
                                                    DRIVER DETAILS
                                                </NavLink>
                                            }
                                        </NavItem>
                                        <NavItem className={this.state.tab === "dailyMileage" ? "active" : "inactive"}>
                                            <NavLink className={this.state.detailSubsections === "dailyMileage" ? "active navItem" : "navItem"} onClick={() => this.toggleSectionNav("detailSubsections", "dailyMileage")}>
                                                DAILY MILEAGE
                                            </NavLink>
                                        </NavItem>
                                    </Nav>
                                    {this.state.detailSubsections === "dailyMileage" &&
                                        <Query
                                            query={DailyMileages}
                                            variables={{ car_Id_Iexact: this.props.rental && this.props.rental.car && this.props.rental.car.id, cursor: null, first: 5 }}
                                            onCompleted={(data) => {
                                                if (!dataLoaded) {
                                                    const edges = data.allDailyMileages.edges || []
                                                    const pageInfo = data.allDailyMileages.pageInfo
                                                    this.setState({
                                                        dailyMileages: edges,
                                                        cursor: pageInfo.endCursor,
                                                        hasNextPage: pageInfo.hasNextPage,
                                                        dataLoaded: true,
                                                    })
                                                }
                                            }}
                                        >
                                            {({ loading, error, fetchMore }) => {
                                                if (loading) return <div className="info-container">
                                                    <Loader />
                                                </div>
                                                if (error) return <div className="info-container">
                                                    <p>Error loading daily mileages</p>
                                                </div>
                                                return (
                                                    <div className="info-container" style={{ borderTopLeftRadius: "0px", maxHeight: "300px", overflow: "auto" }}>
                                                        <Row>
                                                            <Col><Label>Date Added</Label></Col>
                                                            <Col><Label>Date Modified</Label></Col>
                                                            <Col><Label>Mileage</Label></Col>
                                                            <Col><Label>User</Label></Col>
                                                        </Row>
                                                        {dailyMileages.length > 0 ? (
                                                            dailyMileages.map((item) => (
                                                                <Row key={item.node.id}>
                                                                    <Col>
                                                                        <p>{item.node.dateAdded ? <DatetimeRenderer datetime={item.node.dateAdded} /> : "--"}</p>
                                                                    </Col>
                                                                    <Col>
                                                                        <p>{item.node.dateModified ? <DatetimeRenderer datetime={item.node.dateModified} /> : "--"}</p>
                                                                    </Col>
                                                                    <Col>
                                                                        <p>
                                                                            {item.node.mileage
                                                                                ? this.props.rental && this.props.rental.car && this.props.rental.car.branch && this.props.rental.car.branch.defaultMileageUnit === "KM"
                                                                                    ? `${Math.round(item.node.mileage * 1.60934)} KM`
                                                                                    : `${Math.round(item.node.mileage)} MI`
                                                                                : "--"}
                                                                        </p>
                                                                    </Col>
                                                                    <Col>
                                                                        <p>{item.node.history && item.node.history.length > 0 ? item.node.history[0].user : "--"}</p>
                                                                    </Col>
                                                                </Row>
                                                            ))
                                                        ) : (
                                                            <Row><Col>No Daily Mileage found!</Col></Row>
                                                        )}
                                                        <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "20px" }}>
                                                            {hasNextPage && (
                                                                <Button disabled={this.state.loadMore} onClick={() => this.handleLoadMore(fetchMore)} className="primary" size="sm" >
                                                                    {this.state.loadMore ? "Loading..." : <span>Load More &nbsp;<i className="fa fa-angle-down"></i></span>}
                                                                </Button>
                                                            )}
                                                        </div>
                                                    </div>
                                                )
                                            }}
                                        </Query>
                                    }
                                    {this.state.detailSubsections === "carDetails" && this.props.viewType === "driver" &&
                                        <div className="info-container" style={{ margin: "0px", borderTopLeftRadius: "0px" }}>
                                            <Row>
                                                <Col>
                                                    {this.props.rental ?
                                                        <div>
                                                            <Row>
                                                                <Col xs={4}>
                                                                    <Label>Car ID</Label>
                                                                    <p className="columnContent">
                                                                        {this.props.rental.car ? this.props.rental.car.pk : "---"}
                                                                        {this.props.rental.car && this.props.rental.car.pk && <small>&nbsp;<Link color="primary" to={'/car/' + this.props.rental.car.pk}><i className={"fa fa-external-link-square"}></i></Link></small>}
                                                                    </p>
                                                                </Col>
                                                                <Col xs={4}>
                                                                    <Label>Vin</Label>
                                                                    <p className="columnContent">{this.props.rental.car ? this.props.rental.car.vin : "---"}</p>
                                                                </Col>
                                                                <Col xs={4}>
                                                                    <Label>DMV Plate</Label>
                                                                    <p className="columnContent">{this.props.rental.car && this.props.rental.car.plate ? this.props.rental.car.plate.dmvPlate : "---"}</p>
                                                                </Col>
                                                                {this.props.rental && this.props.rental.car && this.props.rental.car.plate && this.props.rental.car.plate.fhv &&
                                                                    <Col xs={4}>
                                                                        <Label>FHV</Label>
                                                                        <p className="columnContent">{this.props.rental.car && this.props.rental.car.plate ? this.props.rental.car.plate.fhv : "---"}</p>
                                                                    </Col>
                                                                }
                                                                <Col xs={4}>
                                                                    <Label>Model</Label>
                                                                    <p className="columnContent">{this.props.rental.car && this.props.rental.car.carModel ? toTitleCase(this.props.rental.car.carModel.make ? this.props.rental.car.carModel.make : "--") + " " + toTitleCase(this.props.rental.car.carModel.name ? this.props.rental.car.carModel.name : "--") : "--"}  <small>{this.props.rental.car && this.props.rental.car.carModel && this.props.rental.car.carModel.series ? this.props.rental.car.carModel.series : ""}</small></p>
                                                                </Col>
                                                                <Col xs={4}>
                                                                    <Label>Group</Label>
                                                                    <p className="columnContent">{this.props.rental.car && this.props.rental.car.carModel && this.props.rental.car.carModel.groupType ? this.props.rental.car.carModel.groupType.name : "--"}</p>
                                                                </Col>
                                                                <Col xs={4}>
                                                                    <Label>Color/Year</Label>
                                                                    <p className="columnContent">{this.props.rental.car ? this.props.rental.car.color : "---"} - {this.props.rental.car ? this.props.rental.car.year : "---"}</p>
                                                                </Col>
                                                                <Col xs={4}>
                                                                    <Label>Policy</Label>
                                                                    <p className="columnContent">
                                                                        {this.props.rental?.car?.activePolicy?.insurancePolicy ?
                                                                            (this.props.rental?.car?.activePolicy?.insurancePolicy?.broker?.name ? this.props.rental.car.activePolicy.insurancePolicy.broker.name : "--") + ": " + this.props.rental?.car?.activePolicy?.insurancePolicy?.policyNumber :
                                                                            "None found"
                                                                        }
                                                                    </p>
                                                                </Col>
                                                                <Col xs={4}>
                                                                    <Label>Car Branch</Label>
                                                                    <p className="columnContent"><span className="bos-badge bos-badge-blue">{this.props.rental && this.props.rental.car && this.props.rental.car.branch ? this.props.rental.car.branch.name : "No Car Branch"}</span> </p>
                                                                </Col>
                                                                {this.props.rental.driver && this.getAgreementState(this.props.rental.stage) !== "Returned" && this.getAgreementState(this.props.rental.stage) !== "Canceled" && this.props.rental.car &&
                                                                    <Fragment>
                                                                        <Col xs={4}>
                                                                            <Label>Equipments</Label>
                                                                            <p className="columnContent">
                                                                                {this.props.rental.car && this.props.rental.car.equipmentSet && this.props.rental.car.equipmentSet.edges && this.props.rental.car.equipmentSet.edges.length > 0 ? this.props.rental.car.equipmentSet.edges.filter((_, i) => i < 1).map((equipment, i) =>
                                                                                    <><Badge size="sm" className={"black text-light"}>{equipment.node.equipmentItems.name}</Badge>&nbsp;&nbsp;</>
                                                                                ) : "None Added"}
                                                                                {this.props.rental.car && this.props.rental.car.equipmentSet && this.props.rental.car.equipmentSet.edges && this.props.rental.car.equipmentSet.edges.length > 1 && <>
                                                                                    <span id={"more-equipments"}>+{this.props.rental.car.equipmentSet.edges.length - 1} more</span>
                                                                                    <UncontrolledTooltip className="more-info-tooltip" target={"more-equipments"} placement="right" delay={{ "show": 400, "hide": 200 }} autohide={false}>
                                                                                        {this.props.rental.car.equipmentSet.edges.filter((_, i) => i >= 1).map((equipment, i) =>
                                                                                            <>
                                                                                                <span>{equipment.node.equipmentItems && equipment.node.equipmentItems.name ? equipment.node.equipmentItems.name : "--"}</span><br />
                                                                                            </>
                                                                                        )}
                                                                                    </UncontrolledTooltip>
                                                                                </>}
                                                                            </p>
                                                                        </Col>
                                                                        {this.props.rental.car && this.props.rental.car.equipmentSet && this.props.rental.car.equipmentSet.edges && this.props.rental.car.equipmentSet.edges.filter(equipment => (
                                                                            equipment.node.equipmentItems.equipmentItemsGroup.name === "GPS")) &&
                                                                            this.props.rental.car.equipmentSet.edges.filter(equipment => (equipment.node.equipmentItems.equipmentItemsGroup.name === "GPS")).map((equipment, index) =>
                                                                                <Col xs={4}>
                                                                                    <Label>
                                                                                        {equipment.node.equipmentItems && equipment.node.equipmentItems.name}
                                                                                    </Label>
                                                                                    <Row>
                                                                                        <Col className="text-left" xs={4}>
                                                                                            <Repo id={"repo" + index} width={25} height={25} onClick={() => this.toggleModal("repo" + index)} />
                                                                                            <UncontrolledTooltip target={"repo" + index} placement="top">Repo Car</UncontrolledTooltip>
                                                                                            {this.state.openModal === "repo" + index &&
                                                                                                <CarTrackerModal trackerId={equipment.node.customDeviceId} driver={this.props.rental.driver} open={this.state.openModal === "repo" + index} handleClose={() => this.toggleModal("repo" + index)} command={"Repo"} car={this.props.rental.car} />
                                                                                            }
                                                                                        </Col>
                                                                                        <Col className="text-left p-0" style={{ borderLeft: "solid black 1px" }}>
                                                                                            &nbsp;
                                                                                            <a id={"locate" + index} href={`${process.env.REACT_APP_FLEETSYNC_URL}/cars/${this.props.rental.car.pk}?tab=Map`} target="_blank" rel="noopener noreferrer" className="bos-custom-link">
                                                                                                <img src={fleetsynclogo} width={"100px"} alt="FleetSync Logo" />
                                                                                            </a>
                                                                                            <UncontrolledTooltip target={"locate" + index} placement="top">For Tracker Actions</UncontrolledTooltip>
                                                                                        </Col>
                                                                                    </Row>
                                                                                </Col>
                                                                            )
                                                                        }
                                                                        <Col xs={4}>
                                                                            <Label>Car Status</Label><br />
                                                                            {this.props.rental.car && this.props.rental.car.hasTracker ?
                                                                                <Badge className={`columnContent ${["Disabled", "Repo", "Pending Disable"].indexOf(this.props.rental.car.trackerStatus) > -1 ? "bg-danger text-light" : ""}`}>{this.props.rental.car.trackerStatus}</Badge>
                                                                                :
                                                                                <Badge className="columnContent text-light">No tracker</Badge>
                                                                            }
                                                                        </Col>
                                                                    </Fragment>
                                                                }
                                                                <Col xs={12}>
                                                                    <Label id={"carNotesEdit"}>
                                                                        Car Notes&nbsp;&nbsp;
                                                                        <i onClick={() => this.toggleModal("notesHistory")} className={"fa fa-history"}></i>&nbsp;&nbsp;
                                                                        <i onClick={() => this.toggleModal("carNotesEdit")} className={"fa fa-pencil-square-o"}></i>&nbsp;&nbsp;
                                                                    </Label>
                                                                    {this.state.openModal === "notesHistory" &&
                                                                        <CarNotes car={this.props.rental.car} target={"carNotesEdit"} open={this.state.openModal === "notesHistory"} handleClose={() => this.toggleModal("")} />
                                                                    }
                                                                    {this.state.openModal === "carNotesEdit" &&
                                                                        <UpdateCarInfo car={this.props.rental.car} title="Edit Notes" name="notes" value={this.props.rental.car.notes} target={"carNotesEdit"} type="text" open={this.state.openModal === "carNotesEdit"} handleClose={() => this.toggleModal("")} refetchQuery={this.props.refetchAgreementsQuery} />
                                                                    }
                                                                    <p className="columnContent">
                                                                        {this.props.rental?.car?.notes ? this.props.rental?.car?.notes : "--"}
                                                                    </p>
                                                                </Col>
                                                            </Row>
                                                        </div> : <p>No Info Found</p>
                                                    }
                                                </Col>
                                            </Row>
                                        </div>}
                                    {this.state.detailSubsections === "driverDetails" && this.props.viewType === "car" &&
                                        <div className="info-container" style={{ margin: "0px", borderTopLeftRadius: "0px" }}>
                                            <Row>
                                                <Col xs={3}>
                                                    <Label>Name</Label>
                                                    <p className="columnContent">{this.props.rental?.driver?.name || "---"} <Link color="primary" to={'/driver/' + this.props.rental.driver.id}><i className={"fa fa-external-link"}></i></Link></p>
                                                </Col>
                                                <Col xs={3}>
                                                    <Label>Phone Number</Label>
                                                    <p className="columnContent">{this.props.rental?.driver?.phone || "---"}</p>
                                                </Col>
                                                <Col xs={3}>
                                                    <Label>Email</Label>
                                                    <p className="email">{this.props.rental?.driver?.email || "---"}</p>
                                                </Col>

                                                <Col xs={3}>
                                                    <Label>DMV</Label>
                                                    <p className="columnContent">{this.props.rental?.driver?.dmvLicense || "---"}</p>
                                                </Col>
                                                <Col xs={3}>
                                                    <Label>TLC</Label>
                                                    <p className="columnContent">{this.props.rental?.driver?.tlcLicense || "---"}</p>
                                                </Col>
                                                <Col xs={3}>
                                                    <Label>Branch</Label>
                                                    <p className="columnContent">{this.props.rental?.driver?.branch?.name || "---"}</p>
                                                </Col>
                                                <Col xs={3} id="paymentMethodEdit">
                                                    <Label><span onClick={() => this.toggleModal("paymentMethodEdit")}>Payment Method</span></Label>
                                                    <p className="columnContent">{this.props.rental?.driver?.paymentMethod?.name || "---"}</p>
                                                </Col>
                                                <Col xs={3} id="chargeDayofweekEdit">
                                                    <Label><span onClick={() => this.toggleModal("chargeDayofweekEdit")}>Invoice Day</span></Label>
                                                    <p className="columnContent">
                                                        {this.props.rental.driver && BILLING_DAYS.filter((day, i) => day.value === this.props.rental.driver.chargeDayofweek).map((day, i) => <span key={i}>{day.label}</span>)}
                                                    </p>
                                                </Col>
                                                <Col xs={3}>
                                                    <Label>CC surcharge</Label>
                                                    <p className="columnContent"><i className={this.props.rental?.driver?.chargeCcsurcharge === true ? "fa fa-toggle-on switch" : "fa fa-toggle-off switch"} aria-hidden="true"></i></p>
                                                </Col>
                                                <Col xs={3}>
                                                    <Label>
                                                        Deposit
                                                    </Label>
                                                    <p className="columnContent">
                                                        {this.props.rental?.driver?.deposit || " ---"}
                                                    </p>
                                                </Col>
                                            </Row>
                                        </div>}
                                </Col>
                            </Row>
                            <br />
                            <Row>
                                <Col style={{ marginBottom: "15px" }}>
                                    <Nav tabs>
                                        <NavItem className={this.state.tab === "Rental Info" ? "active" : "inactive"}>
                                            <NavLink className={this.state.rentalDetailSubsection === "Rental Info" ? "active navItem" : "navItem"} onClick={() => this.toggleSectionNav("rentalDetailSubsection", "Rental Info")}>
                                                RENTAL INFO
                                            </NavLink>
                                        </NavItem>
                                        <NavItem className={this.state.tab === "Rental Pricing" ? "active" : "inactive"}>
                                            <NavLink className={this.state.rentalDetailSubsection === "Rental Pricing" ? "active navItem" : "navItem"} onClick={() => this.toggleSectionNav("rentalDetailSubsection", "Rental Pricing")}>
                                                RENTAL PRICING
                                            </NavLink>
                                        </NavItem>
                                        <NavItem className={this.state.tab === "Rental History" ? "active" : "inactive"}>
                                            <NavLink className={this.state.rentalDetailSubsection === "Rental History" ? "active navItem" : "navItem"} onClick={() => this.toggleSectionNav("rentalDetailSubsection", "Rental History")}>
                                                RENTAL HISTORY
                                            </NavLink>
                                        </NavItem>
                                    </Nav>
                                    {this.state.rentalDetailSubsection === "Rental Info" &&
                                        <div className="info-container" style={{ borderTopLeftRadius: "0px" }}>
                                            {this.props.rental.splitAgreement && <Row>
                                                <Col xs={4}>
                                                    <Label>Split Driver</Label>
                                                    <p className="columnContent">
                                                        {this.props.rental.splitAgreement.driver ? (
                                                            <Link to={"/driver/" + this.props.rental.splitAgreement.driver.id} className="rental-split-driver-link">
                                                                <span className="rental-split-driver-chip">
                                                                    <i className="fa fa-user-o" aria-hidden="true"></i>
                                                                    <span>{this.props.rental.splitAgreement.driver.name}</span>
                                                                    <i className="fa fa-external-link" aria-hidden="true"></i>
                                                                </span>
                                                            </Link>
                                                        ) : "--"}
                                                    </p>
                                                </Col>
                                                <Col xs={4}>
                                                    <Label id={"splitChargesPrimary"}>
                                                        Primary For Split Charges&nbsp;&nbsp;
                                                        <i onClick={() => this.toggleModal("splitChargesPrimaryEdit")} className={"fa fa-pencil-square-o"}></i>
                                                    </Label>
                                                    <p className="columnContent">
                                                        <span className={`bos-badge ${this.props.rental?.isPrimaryForSplitCharges ? "bos-badge-blue" : "badge-secondary"}`}>
                                                            {this.props.rental?.isPrimaryForSplitCharges ? "Yes" : "No"}
                                                        </span>
                                                    </p>
                                                    {this.state.openModal === "splitChargesPrimaryEdit" &&
                                                        <UpdateAgreementInfo
                                                            agreementId={this.props.rental.id}
                                                            title="Primary For Split Charges"
                                                            name="isPrimaryForSplitCharges"
                                                            value={!!this.props.rental.isPrimaryForSplitCharges}
                                                            target={"splitChargesPrimary"}
                                                            id="splitChargesPrimary"
                                                            type="toggle"
                                                            falseLabel="Secondary"
                                                            trueLabel="Primary"
                                                            open={this.state.openModal === "splitChargesPrimaryEdit"}
                                                            handleClose={() => this.toggleModal("")}
                                                            refetchQuery={this.props.refetchAgreementsQuery}
                                                            placement={"left"}
                                                        />
                                                    }
                                                </Col>
                                            </Row>}
                                            <Row>
                                                <Col xs={12}>
                                                    <Row>
                                                        {this.props.rental?.agreementpriceSet?.edges?.length > 0 ?
                                                            this.props.rental.agreementpriceSet.edges.filter(price => price.node.isActive).map((plan, i) =>
                                                                <>
                                                                    <Col xs={4}>
                                                                        <Label>{plan.node.isActive ? "ACTIVE " : ""}Price</Label>
                                                                        <div className="input-alternative-box">{"$" + plan.node.price + " per " + (plan.node.interval > 1 ? plan.node.interval : "") + plan.node.intervalUnit}</div>
                                                                    </Col>
                                                                    <Col xs={4}>
                                                                        <Label>UPCOMING CHARGE</Label>
                                                                        <div className="input-alternative-box">
                                                                            {this.props.rental?.upcomingRentalTask?.amountToCharge ? ("$" + this.props.rental.upcomingRentalTask.amountToCharge + " on ") : "--"}&nbsp;{this.props.rental?.upcomingRentalTask?.scheduleTime ? (<DatetimeRenderer datetime={this.props.rental.upcomingRentalTask.scheduleTime} driverId={this.props.rental?.driver?.id || null} />) : "--"}
                                                                        </div>
                                                                    </Col>
                                                                </>
                                                            ) :
                                                            <>
                                                                <Col xs={4}>
                                                                    <Label>Active Price</Label>
                                                                    <div className="input-alternative-box">--</div>
                                                                </Col>
                                                                <Col xs={4}>
                                                                    <Label>UPCOMING CHARGE</Label>
                                                                    <div className="input-alternative-box">--</div>
                                                                </Col>
                                                            </>
                                                        }
                                                        <Col xs={4}>
                                                            <Label id={"agreementStage"} style={{ display: "block", marginBottom: "10px" }}>Stage&nbsp;&nbsp;
                                                                {this.props.rental && this.props.rental.stage && this.props.currentUser && this.props.hasPermissions && ((this.props.hasPermissions.includes("custom_can_cancel_agreement") && this.props.rental.stage === "A_10") || (this.props.hasPermissions.includes("custom_can_reactivate_agreement") && this.props.rental.stage === "A_50"))
                                                                    && <i onClick={() => this.toggleModal("UpdateAgreementInfo")} className={"fa fa-lg fa-pencil-square"}></i>
                                                                }
                                                            </Label>
                                                            {this.props.rental.stage ?
                                                                <div style={{ color: "white" }}>
                                                                    {<Badge className={this.props.rental.stage === "_1" ? "bg-danger" :
                                                                        this.props.rental.stage === "A_10" ? "bg-success" : "bg-warning"}>{this.getAgreementState(this.props.rental.stage)}</Badge>}
                                                                    {this.props.rental.stage !== "_1" && this.state.openModal === "UpdateAgreementInfo" &&
                                                                        <UpdateAgreementInfo agreementId={this.props.rental.id} title="Change Agreement Stage" name="stage" value={this.getAgreementState(this.props.rental.stage)} target={"agreementStage"} id="agreementStage" type="text" returnStage={this.props.rental.currentReturn && this.props.rental.currentReturn.stage}
                                                                            open={this.state.openModal === "UpdateAgreementInfo"} handleClose={() => this.toggleModal("")} refetchQuery={this.props.refetchAgreementsQuery} placement={"left"}
                                                                        />
                                                                    }
                                                                    <br />
                                                                </div> : "---"
                                                            }
                                                        </Col>
                                                    </Row>
                                                </Col>
                                            </Row>
                                            <br />
                                            <Row>
                                                <Col xs={4}>
                                                    <Label>Start Date</Label>
                                                    <p>{this.props.rental?.startDate ? <DatetimeRenderer datetime={this.props.rental.startDate} driverId={this.props.rental?.driver?.id || null} /> : "--"}
                                                    </p>
                                                </Col>
                                                <Col xs={4}>
                                                    <Label>End Date</Label>
                                                    <p>{this.props.rental?.endDate ? <DatetimeRenderer datetime={this.props.rental.endDate} driverId={this.props.rental?.driver?.id || null} /> : "--"}
                                                    </p>
                                                </Col>
                                                <Col xs={4}>
                                                    <Label>Duration</Label>
                                                    <p>{formatDuration(this.props.rental?.duration)}</p>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col xs={4}>
                                                    <Label>Gas Level</Label>
                                                    <p>{GAS_LABELS[renderEnumToInt(this.props.rental?.pickupCondition?.gas)] || "--"}</p>
                                                </Col>
                                                <Col xs={4}>
                                                    <Label>Mileage</Label>
                                                    <p>{this.props.rental?.pickupCondition?.mileage || "--"}</p>
                                                </Col>
                                                <Col xs={4}>
                                                    <Label id={"agreementDeposit"}>
                                                        Deposit&nbsp;&nbsp;
                                                        {this.props.rental.stage === "A_10" && this.props.currentUser && this.props.hasPermissions && this.props.hasPermissions.includes("custom_can_update_deposit_amount") && <i onClick={() => this.toggleModal("UpdateAgreementDeposit")} className={"fa fa-lg fa-pencil-square"}></i>}
                                                    </Label>
                                                    <p className="columnContent">{toTitleCase(this.props.rental.depositScheme)} - {`$${this.props.rental.depositAmount}`}</p>
                                                    {this.state.openModal === "UpdateAgreementDeposit" &&
                                                        <UpdateAgreementInfo
                                                            agreementId={this.props.rental.id}
                                                            title="Change Agreement Deposit"
                                                            name="deposit"
                                                            value={{ deposit: this.props.rental.deposit, depositScheme: toTitleCase(this.props.rental.depositScheme) }}
                                                            target={"agreementDeposit"}
                                                            id="agreementDeposit"
                                                            open={this.state.openModal === "UpdateAgreementDeposit"}
                                                            handleClose={() => this.toggleModal("")}
                                                            refetchQuery={this.props.refetchAgreementsQuery}
                                                            placement={"left"}
                                                        />
                                                    }
                                                </Col>
                                                <Col xs={4}>
                                                    <Label>Agreement Branch</Label>
                                                    <p className="columnContent"><span className="bos-badge bos-badge-blue">{this.props.rental?.branch ? this.props.rental.branch.name : "No Agreement Branch"}</span> </p>
                                                </Col>
                                                <Col xs={4}>
                                                    <Label>
                                                        Insurance Surcharge&nbsp;&nbsp;
                                                        {this.props.hasPermissions?.includes("custom_can_edit_insurance_surcharge") &&
                                                            <i id={"updateSurcharge"} onClick={() => this.toggleModal("updateSurcharge")} className={"fa fa-pencil-square-o"}></i>}&nbsp;&nbsp;
                                                    </Label>
                                                    {this.state.openModal === "updateSurcharge" &&
                                                        <UpdateAgreementInfo
                                                            agreementId={this.props.rental.id}
                                                            title="Update Agreement Surcharge"
                                                            name="insuranceUpcharge"
                                                            value={Math.max(0, this.props.rental.insuranceUpcharge || 0)}
                                                            target={"updateSurcharge"}
                                                            id="updateSurcharge"
                                                            type="text"
                                                            open={this.state.openModal === "updateSurcharge"}
                                                            handleClose={() => this.toggleModal("")}
                                                            refetchQuery={this.props.refetchAgreementsQuery}
                                                            placement={"top"}
                                                        />
                                                    }
                                                    <p className="columnContent">
                                                        {Math.max(0, this.props.rental.insuranceUpcharge || 0)}
                                                    </p>
                                                </Col>
                                                <Col xs={4}>
                                                    <Label >
                                                        Contract Status&nbsp;&nbsp;&nbsp;&nbsp;
                                                        {this.props.rental && !this.props.rental.isContractSigned && this.props.rental.stage === "A_10" &&
                                                            <>
                                                                <i id={"uploadContract"} className="fa fa-upload fa-lg" aria-hidden="true" onClick={() => this.toggleModal("uploadContract")} ></i>
                                                                <UncontrolledTooltip target={"uploadContract"} placement="top">Signed contract missing. Click here to upload signed contract.</UncontrolledTooltip>
                                                                {this.state.openModal === "uploadContract" &&
                                                                    <UploadDocumentModal
                                                                        handleClose={() => this.toggleModal("uploadContract")}
                                                                        open={this.state.openModal === "uploadContract"}
                                                                        objectType={"driver"}
                                                                        id={this.props.rental && this.props.rental.driver && this.props.rental.driver.id}
                                                                        agreementId={this.props.rental.id}
                                                                        refetchQuery={this.props.refetchAgreementsQuery ? this.props.refetchAgreementsQuery : () => { return true }}
                                                                    />
                                                                }
                                                            </>
                                                        }
                                                    </Label>
                                                    <p style={{ color: this.props.rental && this.props.rental.isContractSigned ? "green" : "orange" }}>
                                                        {this.props.rental && this.props.rental.isContractSigned ? "Signed" : "Not Signed"}
                                                    </p>
                                                </Col>
                                                <Col xs={4}>
                                                    <Label>Inspections</Label>
                                                    <p>
                                                        {this.props.rental?.pickupCondition?.carpicturesSet?.edges?.length > 0 &&
                                                            <><a href="#" onClick={() => this.viewImages(this.props.rental.pickupCondition)}>PICKUP PICTURES</a>&nbsp;&nbsp;</>
                                                        }
                                                        {this.props.rental?.pickupCondition?.id &&
                                                            <><Link to={`/car/${this.props.rental.car.pk}?inspectionId=${this.props.rental.pickupCondition.id}#inspections`}>PICKUP INSPECTION</Link>&nbsp;&nbsp;</>
                                                        }
                                                        {this.props.rental?.returnCondition?.carpicturesSet?.edges &&
                                                            <><a href="#" onClick={() => this.viewImages(this.props.rental.returnCondition)}>RETURN PICTURES</a>&nbsp;&nbsp;</>
                                                        }
                                                        {this.props.rental?.incidentSet?.edges?.filter(item => item.node && item.node.carCondition !== null).length > 0 ? this.props.rental.incidentSet.edges.filter(item => item.node.carCondition !== null).map((incident) => <>
                                                            <Link to={`/car/${this.props.rental.car.pk}?inspectionId=${incident.node.carCondition.id}&incidentId=${incident.node.id}#inspections`}>{incident.node.carCondition.formType} INSPECTION #{incident.node.pk}</Link>
                                                            &nbsp;&nbsp;</>
                                                        ) : this.props.rental && this.props.rental.returnCondition && this.props.rental.returnCondition.id ?
                                                            <><Link to={`/car/${this.props.rental.car.pk}?inspectionId=${this.props.rental.returnCondition.id}#inspections`}>RETURN INSPECTION</Link>&nbsp;&nbsp;</>
                                                            : ""
                                                        }

                                                        {(this.props.rental.stage === "A_10" || (this.props.rental?.currentReturn?.stage === "A_5" && this.props.rental.stage === "A_50")) && this.props.rental &&
                                                            <>
                                                                <Button size="sm" id={"addNewIncident"} onClick={() => this.toggleModal("addNewIncident")} className="primary">Add New Incident</Button>
                                                                &nbsp;&nbsp;
                                                            </>
                                                        }
                                                        {this.props.rental && this.props.rental.incidentSet.edges && this.props.rental.incidentSet.edges.filter(item => item.node && item.node.carCondition === null).length > 0 &&
                                                            <Button size="sm" id={"pendingInspections"} onClick={() => this.toggleModal("pendingInspections")} className="primary">{this.props.rental.incidentSet.edges.filter(item => item.node && item.node.carCondition === null).length} Pending Inspection</Button>
                                                        }
                                                    </p>
                                                    {this.state.openModal === "addNewIncident" &&
                                                        <AddNewIncidentModal
                                                            isOpen={this.state.openModal === "addNewIncident"}
                                                            toggle={() => this.toggleModal("addNewIncident")}
                                                            refetchQuery={this.props.refetchAgreementsQuery}
                                                            agreementId={this.props.rental.id}
                                                            maxIncidentDate={this.props.rental.endDate || null}
                                                            branchId={this.props.rental?.branch?.id}
                                                        />
                                                    }
                                                    {this.state.openModal === "pendingInspections" &&
                                                        <Popover trigger="legacy" placement="left" target={"pendingInspections"} isOpen={this.state.openModal === "pendingInspections"} toggle={() => this.toggleModal("pendingInspections")} style={{ minWidth: "700px" }}>
                                                            <PopoverHeader>Pending Incidents</PopoverHeader>
                                                            <PopoverBody style={{ backgroundColor: "white" }}>
                                                                <Row style={{ fontWeight: 600 }}>
                                                                    <Col><Label>Date Added</Label></Col>
                                                                    <Col><Label>Title</Label></Col>
                                                                    <Col><Label>Incident Date</Label></Col>
                                                                    <Col><Label>Notification Date</Label></Col>
                                                                    <Col><Label>Reported By</Label></Col>
                                                                </Row>
                                                                {this.props.rental && this.props.rental.incidentSet.edges && this.props.rental.incidentSet.edges.filter(item => item.node && item.node.carCondition === null).length > 0 &&
                                                                    this.props.rental.incidentSet.edges.filter(item => item.node.carCondition === null).map(item =>
                                                                        <Row>
                                                                            <Col><p>{item.node?.dateAdded ? <DatetimeRenderer datetime={item.node.dateAdded} /> : "---"}</p></Col>
                                                                            <Col><p>{item.node?.title ? item.node.title : "---"}</p></Col>
                                                                            <Col><p>{item.node?.incidentDate ? <DatetimeRenderer datetime={item.node.incidentDate} /> : "---"}</p></Col>
                                                                            <Col><p>{item.node?.notificationDate ? <DatetimeRenderer datetime={item.node.notificationDate} driverId={this.props.rental?.driver?.id || null} /> : "---"}</p></Col>
                                                                            <Col><p>{item.node?.reportedBy ? toTitleCase(item.node.reportedBy) : "---"}</p></Col>
                                                                        </Row>
                                                                    )
                                                                }
                                                            </PopoverBody>
                                                        </Popover>
                                                    }
                                                </Col>
                                                {["ft", "vgm", "ucars"].includes(this.props.rental?.driver?.branch?.tenant?.customId) && <Col xs={4}>
                                                    <Label>
                                                        Driversmart Status
                                                        {this.props.rental?.stage === "A_10" && (carIsEligibleForDriveSmart || this.props.rental?.participateInDriveSmart) && <>
                                                            &nbsp;&nbsp;
                                                            <i className={"fa fa-pencil-square-o"} aria-hidden="true" onClick={() => this.toggleModal("editDriversmartStatus")} ></i>
                                                            {this.state.openModal === "editDriversmartStatus" &&
                                                                <DriverSmartStatusModal
                                                                    isOpen={this.state.openModal === "editDriversmartStatus"}
                                                                    toggle={() => this.toggleModal("editDriversmartStatus")}
                                                                    handleClose={() => this.toggleModal("")}
                                                                    currentStatus={this.props.rental?.participateInDriveSmart}
                                                                    agreementId={this.props.rental?.id}
                                                                    refetchQuery={this.props.refetchAgreementsQuery}
                                                                />
                                                            }
                                                        </>}
                                                    </Label>
                                                    <p>{this.props.rental?.participateInDriveSmart !== null ? <><Badge className="text-light" pill size="sm" style={{ background: "black" }}>{this.props.rental?.participateInDriveSmart === true ? "Accepted Driver Smart" : "Declined Driver Smart"}</Badge>&nbsp;</> : "--"}</p>
                                                </Col>}
                                                {rental.leaseToOwn && rental.leaseToOwn.car &&
                                                    <>
                                                        <Col xs={4}>
                                                            <Label>LTO Car</Label>
                                                            <p className="columnContent">
                                                                <Badge className="text-light" pill size="sm">{rental.leaseToOwn.status}</Badge> {rental.leaseToOwn.car.year} {rental.leaseToOwn.car.make} {rental.leaseToOwn.car.model}
                                                                <small>&nbsp;<Link color="primary" to={'/car/' + rental.leaseToOwn.car.pk}><i className={"fa fa-external-link-square"}></i></Link></small>
                                                            </p>
                                                        </Col>
                                                        <Col xs={4}>
                                                            <Label>LTO Total Lease Amount</Label>
                                                            <p className="columnContent">{rental.leaseToOwn.totalLeaseAmount || '--'}</p>
                                                        </Col>
                                                        <Col xs={4}>
                                                            <Label>LTO Total Lease Term</Label>
                                                            <p className="columnContent">{rental.leaseToOwn.leaseTermInMonths || '--'}</p>
                                                        </Col>
                                                    </>
                                                }
                                                <Col xs={4}>
                                                    <Label>Agreement Type</Label>
                                                    <p>{this.props.rental?.agreementType ? toTitleCase(this.props.rental.agreementType) : "--"}</p>
                                                </Col>
                                                {this.props.rental?.leaseToOwn && (
                                                    <Col xs={4}>
                                                        <Label>Total LTO Duration</Label>
                                                        <p>
                                                            {this.props.rental?.leaseToOwn?.totalDuration !== undefined ? `${this.props.rental.leaseToOwn.totalDuration} ${this.props.rental.leaseToOwn.totalDuration === 1 ? 'Day' : 'Days'}` : '--'}
                                                        </p>
                                                    </Col>
                                                )}
                                                <Col xs={4}>
                                                    <Label id={"agreementPickupType" + this.props.rental.pk}>
                                                        Pickup Type
                                                    </Label>
                                                    <p>
                                                        {toTitleCase(this.props.rental.pickupType)}
                                                    </p>
                                                </Col>
                                                <Col xs={8}>
                                                    <Label id={"agreementNotesEdit" + this.props.rental.pk}>
                                                        Notes&nbsp;&nbsp;
                                                        <i onClick={() => this.toggleModal("agreementNotesEdit" + this.props.rental.pk)} className={"fa fa-pencil-square-o"}></i>&nbsp;&nbsp;
                                                        {this.state.openModal === "agreementNotesEdit" + this.props.rental.pk &&
                                                            <UpdateAgreementInfo
                                                                agreementId={this.props.rental.id}
                                                                title="Update Notes"
                                                                name="notes"
                                                                value={this.props.rental.notes}
                                                                target={"agreementNotesEdit" + this.props.rental.pk}
                                                                id={"agreementNotesEdit" + this.props.rental.pk}
                                                                type="text"
                                                                open={this.state.openModal === "agreementNotesEdit" + this.props.rental.pk}
                                                                handleClose={() => this.toggleModal("")}
                                                                refetchQuery={this.props.refetchAgreementsQuery}
                                                                placement={"top"}
                                                            />
                                                        }
                                                    </Label>
                                                    <p>
                                                        {this.props.rental.notes ? this.props.rental.notes : "No Rental Notes Found"}
                                                    </p>
                                                </Col>
                                            </Row>
                                        </div>
                                    }
                                    {this.state.rentalDetailSubsection === "Rental History" &&
                                        <div className="info-container" style={{ borderTopLeftRadius: "0px", maxHeight: "300px", overflow: "auto" }}>
                                            <HistoryList objectIds={[this.props.rental?.id]} />
                                        </div>
                                    }
                                    {this.state.rentalDetailSubsection === "Rental Pricing" &&
                                        <div className="info-container" style={{ borderTopLeftRadius: "0px" }}>
                                            <Row>
                                                {<NewAgreementPrice handleClose={() => this.toggleModal("")} refetchQuery={this.props.refetchAgreementsQuery} rental={this.props.rental} open={this.state.openModal === "NewAgreementPrice"} />}
                                                {this.props.rental && this.props.rental.stage === "A_10" &&
                                                    <Col className="d-flex justify-content-end">
                                                        <Button size="sm" onClick={() => this.toggleModal("NewAgreementPrice")} className="primary">Add/Change Plan</Button>
                                                        <p></p>
                                                    </Col>
                                                }
                                            </Row>
                                            <Row>
                                                {this.props.rental && this.props.rental.agreementpriceSet && this.props.rental.agreementpriceSet.edges && this.props.rental.agreementpriceSet.edges.length > 0 && PRICING_TABLE_HEADER.map(tableHeader =>
                                                    <Col key={tableHeader.id}>
                                                        <Label>{tableHeader.name}</Label>
                                                    </Col>
                                                )}
                                            </Row>
                                            {this.props.rental && this.props.rental.agreementpriceSet && this.props.rental.agreementpriceSet.edges && this.props.rental.agreementpriceSet.edges.length > 0 ? this.props.rental.agreementpriceSet.edges.map(plan =>
                                                <Row className={plan.node.isActive ? "activePrice" : ""} style={{ background: "#3e4c6d", opacity: plan.node.isActive ? 1 : 0.8, color: "white", padding: "5px", borderRadius: "5px", justifyContent: "center", alignItems: "center" }}>
                                                    <Col>${plan.node.price} per {plan.node.interval > 1 ? plan.node.interval : ""}{plan.node.intervalUnit}</Col>
                                                    <Col>{plan.node.startDate ? <DatetimeRenderer datetime={plan.node.startDate} format={"ddd, MMM Do"} /> : "--"}</Col>
                                                    <Col>{plan.node.isActive ? "ACTIVE" : "IN-ACTIVE"}</Col>
                                                    <Col>{this.props.rental.representative ? this.props.rental.representative.firstName ? this.props.rental.representative.firstName + " " + this.props.rental.representative.lastName : this.props.rental.representative.username : "--"}</Col>
                                                </Row>) : <Row><Col xs={12}><p>No Rental Price Found</p></Col></Row>
                                            }
                                            <br />
                                            {this.props.rental && this.props.rental.agreementpromoSet && this.props.rental.agreementpromoSet.edges && this.props.rental.agreementpromoSet.edges.length > 0 ? this.props.rental.agreementpromoSet.edges.map((promo, index) =>
                                                <Row key={promo.node.id} style={{ backgroundColor: "green", color: "white", padding: "5px", borderRadius: "5px", justifyContent: "center", alignItems: "center", opacity: !promo.node.isPending ? 1 : 0.8 }} id={`cancel-promo-btn-${index}`}>
                                                    <Col><i className="fa fa-tags" aria-hidden="true" />&nbsp;&nbsp;{!promo.node.isPercentage ? "$" : ""}{promo.node.promoPrice}{promo.node.isPercentage ? "%" : ""} per {promo.node.interval > 1 ? promo.node.interval : ""}{promo.node.intervalUnit}</Col>
                                                    <Col>{promo.node.startDate ? <DatetimeRenderer datetime={promo.node.startDate} /> : "--"}</Col>
                                                    <Col>
                                                        <small id={`promo-expiration-${index}`}>
                                                            {promo.node.isActive ? (promo.node.isPending ? "PENDING" : "ACTIVE") : "IN-ACTIVE"} ({promo?.node?.expirationDate || "--"})
                                                        </small>
                                                        <UncontrolledTooltip placement='top' target={`promo-expiration-${index}`}>Expiration date</UncontrolledTooltip>
                                                    </Col>
                                                    <Col>{promo.node.createdBy ? promo.node.createdBy.firstName ? promo.node.createdBy.firstName + " " + promo.node.createdBy.lastName : promo.node.createdBy.username : "--"}</Col>
                                                </Row>) : <Row><Col xs={12}><p>No Promo Found</p></Col></Row>

                                            }
                                        </div>

                                    }
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Nav tabs>
                                        <NavItem className={this.state.tab === "Return Info" ? "active" : "inactive"}>
                                            <NavLink className={this.state.returnDetailSubsection === "Return Info" ? "active navItem" : "navItem"} onClick={() => this.toggleSectionNav("returnDetailSubsection", "Return Info")}>
                                                RETURN INFO
                                            </NavLink>
                                        </NavItem>
                                        <NavItem className={this.state.tab === "Return History" ? "active" : "inactive"}>
                                            <NavLink className={this.state.returnDetailSubsection === "Return History" ? "active navItem" : "navItem"} onClick={() => this.toggleSectionNav("returnDetailSubsection", "Return History")}>
                                                RETURN HISTORY
                                            </NavLink>
                                        </NavItem>
                                    </Nav>
                                    {this.state.returnDetailSubsection === "Return Info" &&
                                        <div className="info-container" style={{ borderTopLeftRadius: "0px" }}>
                                            {this.props.rental.currentReturn ?
                                                this.renderCarReturn(this.props.rental.currentReturn, this.props.rental) :
                                                this.getAgreementState(this.props.rental.stage) && this.getAgreementState(this.props.rental.stage).includes("Active") ?
                                                    <Row>
                                                        {this.props.rental &&
                                                            <Col xs={12}>
                                                                {this.state.openModal === "ScheduleReturnForm" + this.props.rental.id && <ScheduleReturnForm refetchQuery={this.props.refetchAgreementsQuery} handleClose={() => this.toggleModal("")} rental={this.props.rental} open={this.state.openModal === "ScheduleReturnForm" + this.props.rental.id} currentUser={this.props.currentUser ? this.props.currentUser : ""} />}
                                                                <Button className="primary" onClick={() => this.toggleModal("ScheduleReturnForm" + this.props.rental.id)}>Schedule Return</Button>&nbsp;&nbsp;
                                                            </Col>
                                                        }
                                                    </Row> :
                                                    <Row>
                                                        <Col xs={12}>
                                                            <p className="columnContent">No Return Information Available.</p>
                                                        </Col>
                                                    </Row>
                                            }
                                        </div>
                                    }
                                    {this.state.returnDetailSubsection === "Return History" &&
                                        <div className="info-container" style={{ borderTopLeftRadius: "0px" }}>
                                            <Row>
                                                <Col><Label>Date Added</Label></Col>
                                                <Col><Label>Return Category</Label></Col>
                                                <Col><Label>Driver Cancel Reason</Label></Col>
                                                <Col><Label>Cancelled Date</Label></Col>
                                                <Col><Label>Scheduled Date</Label></Col>
                                                <Col><Label>Auto Deposit Refund</Label></Col>
                                                <Col><Label>Rep</Label></Col>
                                            </Row>
                                            {
                                                this.props.rental.carreturnSet &&
                                                    this.props.rental.carreturnSet.edges &&
                                                    this.props.rental.carreturnSet.edges.length > 0 &&
                                                    this.props.rental.carreturnSet.edges.length > 0 ?
                                                    this.props.rental.carreturnSet.edges.filter(item => !this.props.rental.currentReturn || item.node.id !== this.props.rental.currentReturn.id).reverse().map((item, i) =>
                                                        <Row key={item.node.id}>
                                                            <Col>
                                                                <p>{item.node.dateAdded ? <DatetimeRenderer datetime={item.node.dateAdded} /> : "--"} {item.node.isDeleted && <Badge color="danger text-light">Deleted</Badge>}</p>
                                                            </Col>
                                                            <Col>
                                                                <p>{toTitleCase(item.node.returnCategory)} {this.fetchMetaData(item.node.metadata, "incomplete_return") ? <><Badge color="danger text-light" id={"IR" + i}>IR</Badge><UncontrolledTooltip target={"IR" + i}>Incomplete Return</UncontrolledTooltip> </> : ""}</p>
                                                            </Col>
                                                            <Col>
                                                                <p>{item.node.returnReason}</p>
                                                            </Col>
                                                            <Col>
                                                                <p>{item.node.cancelledDate ? <DatetimeRenderer datetime={item.node.cancelledDate} /> : "--"}</p>
                                                            </Col>
                                                            <Col>
                                                                <p>{item.node.scheduledDate ? <DatetimeRenderer datetime={item.node.scheduledDate} /> : "--"}</p>
                                                            </Col>
                                                            <Col>
                                                                <p className="columnContent" style={{ color: item.node.autoDepositRefund ? "green" : "red" }}>{item.node.autoDepositRefund ? "YES" : "NO"}</p>
                                                            </Col>
                                                            <Col>
                                                                <p>{item.node.representative ? item.node.representative.firstName ? item.node.representative.firstName + " " + item.node.representative.lastName : item.node.representative.username : "--"}</p>
                                                            </Col>
                                                        </Row>
                                                    ) :
                                                    <Row><Col><p> No returns history found! </p></Col></Row>}
                                        </div>
                                    }
                                </Col>
                            </Row>
                            <br />
                            {this.props.rental && this.props.rental.driver && this.props.rental.driver.branch && this.props.rental.driver.branch.tenant && this.props.rental.driver.branch.tenant.customId !== "mnave" &&
                                <Row >
                                    <Col>
                                        <Nav tabs>
                                            <NavItem className={this.state.tab === "Transactions History" ? "active" : "inactive"}>
                                                <NavLink className={this.state.agreementDetailSubsection === "Transactions History" ? "active navItem" : "navItem"} onClick={() => this.toggleSectionNav("agreementDetailSubsection", "Transactions History")}>
                                                    TRANSACTIONS HISTORY
                                                </NavLink>
                                            </NavItem>
                                        </Nav>
                                        <div className="info-container" style={{ borderTopLeftRadius: "0px", maxHeight: "300px", overflow: "auto" }}>
                                            {this.state.agreementDetailSubsection === "Transactions History" &&
                                                <>
                                                    <Row style={{ position: "sticky", top: "-1" }}>
                                                        {RENTAL_TRANSACTIONS_HEADER.map(tableHeader => {
                                                            return (
                                                                tableHeader.sortable ?
                                                                    <Col>
                                                                        <Label key={tableHeader.id} onClick={() => this.updateOrder(tableHeader.id)} style={{ cursor: "pointer" }}>{tableHeader.name}</Label>
                                                                    </Col> :
                                                                    <Col>
                                                                        <Label key={tableHeader.id}>{tableHeader.name}</Label>
                                                                    </Col>
                                                            )
                                                        })
                                                        }
                                                    </Row>

                                                    {this.props.rental?.transactionSet?.edges?.length > 0 ? this.props.rental.transactionSet.edges.map((transaction, i) =>
                                                        <Row key={i + 1}>
                                                            <Col>
                                                                <p>
                                                                    {transaction.node.pk}
                                                                    {transaction.node.updateFor && <><br /><small style={{ opacity: 0.9, fontSize: "0.9rem", textDecoration: "line-through" }}>{transaction.node.updateFor.pk}</small></>}
                                                                </p>
                                                            </Col>
                                                            <Col><p>{transaction.node.dateAdded ? <DatetimeRenderer datetime={transaction.node.dateAdded} /> : "--"}</p></Col>
                                                            <Col className={`shortText ${transaction.node.amount > 0 ? "danger" : "success"}`}>
                                                                <p>
                                                                    {transaction.node.chargeType ? transaction.node.chargeType.name : '--'} <small>{transaction.node.groupType ? " (" + transaction.node.groupType.name + ")" : ''}</small>
                                                                    {transaction.node.notes &&
                                                                        <>
                                                                            <UncontrolledTooltip placement="top" target={"notes" + i}>{transaction.node.notes}</UncontrolledTooltip>
                                                                            <br /><small style={{ opacity: 0.9, fontSize: "0.9rem", cursor: "pointer" }} id={"notes" + i}>{transaction.node.notes}</small>
                                                                        </>
                                                                    }
                                                                </p>
                                                            </Col>
                                                            <Col className={transaction.node.amount > 0 ? "danger" : "success"}>
                                                                <p>
                                                                    {transaction.node.amount}
                                                                    {transaction.node.status === "0" && <Badge className="text-light" style={{ "fontSize": "xx-small" }}>PENDING</Badge>}
                                                                </p>
                                                            </Col>
                                                            <Col><p>{transaction.node.eventDatetime ? <DatetimeRenderer datetime={transaction.node.eventDatetime} /> : "--"}</p></Col>
                                                            <Col><p>{transaction.node.createdBy ? transaction.node.createdBy.firstName ? transaction.node.createdBy.firstName + " " + transaction.node.createdBy.lastName : transaction.node.createdBy.username : "System"}</p></Col>
                                                        </Row>) :
                                                        this.props.loading ?
                                                            <Row>
                                                                <Col>&nbsp;&nbsp;&nbsp;Loading Transactions List...</Col>
                                                            </Row> :
                                                            <Row>
                                                                <Col>&nbsp;&nbsp;&nbsp;No Transaction Found</Col>
                                                            </Row>
                                                    }
                                                </>
                                            }
                                        </div>
                                    </Col>
                                </Row>}
                        </div >}
                    </>}
                </Col >

            </>
        )
    }
}

export default graphql(EnumQuery, {
    props: ({ data: { agreementStates, carReturnStates } }) => ({
        agreementStates,
        carReturnStates,
    }),
})(
    graphql(AgreementDetailQuery, {
        options: ({ id, viewType }) => ({
            variables: {
                id,
                loadDriverDetails: viewType === "car" ? true : false,
                loadCarDetails: viewType === "driver" ? true : false,
            },
            fetchPolicy: 'network-only',
            notifyOnNetworkStatusChange: true,
        }),
        props: ({ data: { loading, rental, fetchMore, variables } }) => ({
            loading,
            rental,
            variables,
            refetchAgreementsQuery: () =>
                fetchMore({
                    query: AgreementDetailQuery,
                    variables: { ...variables },
                    updateQuery: (previousResult, { fetchMoreResult }) => ({
                        rental: fetchMoreResult.rental,
                        __typename: previousResult.rental.__typename,
                    }),
                }),
        }),
    })(
        graphql(HasPermissionsQuery, {
            options: () => ({
                variables: {
                    userPermissions: [
                        'custom_can_cancel_agreement',
                        'custom_can_reactivate_agreement',
                        'custom_can_update_deposit_amount',
                        'custom_can_edit_insurance_surcharge',
                        'custom_can_create_incomplete_return',
                    ],
                },
                fetchPolicy: 'network-only',
                notifyOnNetworkStatusChange: true,
            }),
            props: ({ data: { hasPermissions, loading, variables } }) => ({
                hasPermissions,
                loading,
                variables,
            }),
        })(withApolloClient(RentalDetails))
    )
)
